import { gql } from '@apollo/client';

export default gql`
  mutation ReportIssue($input: ReportIssueInput!) {
    reportIssue(input: $input) {
      id
    }
  }
`;
